module.exports = __webpack_public_path__ + "20a6371017eef9f392806b002dc7fc73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/russell.png
// module id = 1728
// module chunks = 0